import React from "react";

const MainLoader = ({ text = "Loading..." }) => {
  return (
    <div className="loading-container">
      <div className="loader"></div>
      <p className="loading-text">{text}</p>
    </div>
  );
};

export default MainLoader;